import React from "react";

const HealthCheck = ()=>{
  return <div>
        check status
  </div>;
};
export default HealthCheck;
